export default "__VITE_ASSET__BL4rGUL___"